import m from "mithril";
/*
 Custom Props:
 * value (String|Number)
 * options (Array[{value,label}|String|Number])
 * firstLabel: (String)
 */
const normalizeOption = function (option) {
    return (typeof option === 'object' && 'label' in option) ? option : {
        value: option,
        label: option,
    };
};

const selectbox = {
    // controller: function (props) {
    //     const ctrl = this;
    //  },

    normalizeOption: normalizeOption,

    view: function (ctrl, props) {
        const options = props.options;
        delete props.options;
        const selectedValue = props.value;
        delete props.value;
        const firstLabel = props.firstLabel;
        delete props.firstLabel;

        return (
            m('select', props,
                firstLabel ? m('option', {value: ''}, firstLabel) : '',
                options.map(function (option) {
                    option = normalizeOption(option);
                    return (
                        m('option', {
                                value: option.value,
                                disabled: !!option.disabled,
                                selected: (option.value === selectedValue)
                            },
                            option.label
                        )
                    );
                })
            )
        );
    },

};

export default selectbox;